import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./rootSaga";
import { snackbarsReducer } from "./snackbarsSlice/snackbarsSlice";
import { featureFlagReducer } from "./featureFlag/featureFlagSlice";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    snackbars: snackbarsReducer,
    featureFlag: featureFlagReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: false }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;
